import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}subwarehouse`;

export const SubwarehouseService = {
    getAll,
    getByWarehouseId,
    getById,
    create,
    update,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getById(id) {
    return fetchWrapper.get(`${baseUrl}/subWarehouse-id?subWarehouseId=${id}`);
}

function getByWarehouseId(id) {
    return fetchWrapper.get(`${baseUrl}/warehouse-id?warehouseId=${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}
